import script from "./LightQrRegistPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LightQrRegistPage.vue?vue&type=script&setup=true&lang=js"

import "./LightQrRegistPage.vue?vue&type=style&index=0&id=cb4ab532&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb4ab532"]])

export default __exports__